import '../scss/author.scss';

import menuModule from "./modules/menu.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import 'lightbox2'

(function ($) {
    $(document).ready(function () {
        menuModule.init();
        scrollUpModule.init();
        footerModule.init();
    });
}(jQuery));



